import React from 'react';
import useMoment from '../../hooks/useMoment';

function LetterDateTop({ date, fontSize = 28 }) {
    const { paperSolarDateString, paperLunarDateString, dateNow } = useMoment();
    const fromDate = date || dateNow();

	return (
		<div style={{ textAlign: "right", lineHeight: 2, padding: "0.4em 0.3em" }}>
			<p style={{ fontSize, fontFamily: "KhmerOSSiemreap", display: "inline-block", transform: "skewX(-20deg)", transformOrigin: "right", margin: 0 }}>{paperLunarDateString(fromDate)}</p>
			<p style={{ fontSize, fontFamily: "KhmerOSSiemreap", display: "inline-block", transform: "skewX(-20deg)", transformOrigin: "right", margin: 0 }}>{paperSolarDateString(fromDate)}</p>
		</div>
	);
}

export default LetterDateTop;
